import * as Api from '../api/Api';
import createAxios from '../api/WiseOwl';

export function getLlmModels() {
    return createAxios().get(Api.PATH_LLM_MODELS);
};

export const removeLlmModel = (id) => {
    return createAxios().delete(Api.PATH_LLM_MODELS + "/" + id);
}

export const createLlmModel = (values) => {
    return createAxios().post(Api.PATH_LLM_MODELS, values);
};

export const updateLlmModel = (id, values) => {
    return createAxios().put(`${Api.PATH_LLM_MODELS}/${id}`, values);
};

export const getProjectLlmModels = (projectId) => {
    return createAxios().get(`${Api.PATH_PROJECTS}/${projectId}${Api.SUB_PATH_PROJECT_LLM_MODELS}`);
}

export const bindProjectLlmModel = (projectId, modelId) => {
    return createAxios().post(`${Api.PATH_PROJECTS}/${projectId}${Api.SUB_PATH_PROJECT_LLM_MODELS}/${modelId}`);
}

export const unbindProjectLlmModel = (projectId, modelId) => {
    return createAxios().delete(`${Api.PATH_PROJECTS}/${projectId}${Api.SUB_PATH_PROJECT_LLM_MODELS}/${modelId}`);
}

export const reorderProjectLlmModels = (projectId, modelIds) => {
    return createAxios().put(`${Api.PATH_PROJECTS}/${projectId}${Api.SUB_PATH_PROJECT_LLM_MODELS_ORDER}`, { items: modelIds });
}
